<div class="fx-layout-row fx-justify-space-between">
  <div class="fx-layout-row">
    <span>{{ field.label }}</span>
    @if (required) {
      <span matTooltipPosition="right" [matTooltip]="'TOOLTIP.REQUIRED_FIELD' | translate" class="required"> * </span>
    }
  </div>
  @if (computed) {
    <span matTooltipPosition="right" [matTooltip]="'TOOLTIP.COMPUTED_FIELD' | translate">
      <i class="mdi mdi-calculator tooltip-icon"></i>
    </span>
  }
</div>
